var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bonus"
  }, [_vm.isEnd && _vm.isUser ? _c('UIDataEntity', {
    attrs: {
      "params": {
        code: 'okhotnik_za_vigodoy'
      },
      "get": _vm.$api.user.addUserAchievement
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bonus__wrap"
  }, [_c('div', {
    attrs: {
      "id": "captcha-container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bonus__main"
  }, [_c('div', {
    staticClass: "bonus__card",
    class: {
      'bonus__card-mobile': _vm.userAuth
    }
  }, [_c('div', {
    staticClass: "bonus__desc"
  }, [_c('h1', {
    staticClass: "bonus__desc-title"
  }, [_vm._v("\n            Покупайте за бонусы!\n          ")]), _vm._v(" "), _c('h5', {
    staticClass: "bonus__desc-description"
  }, [_vm._v("\n            Копите бонусы и оплачивайте ими ваши покупки\n          ")]), _vm._v(" "), !_vm.userAuth ? _c('button', {
    staticClass: "bonus__desc-btn",
    on: {
      "click": function ($event) {
        _vm.showAutModal({
          onComplete: function () {
            return _vm.$router.push('/user/bonus/');
          },
          note: 'Бонусная карта будет автоматически создана при регистрации на сайте'
        });
      }
    }
  }, [_vm._v("\n            Открыть бонусную карту\n          ")]) : _c('button', {
    staticClass: "bonus__desc-btn",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/user/bonus/');
      }
    }
  }, [_vm._v("\n            Открыть личный кабинет\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "bonus__desc-card"
  }, [_c('UserBonusCardBalance', {
    attrs: {
      "data": _vm.bonusData,
      "animation-balance": true,
      "user-auth": _vm.userAuth
    }
  }), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), _vm.userAuth ? _c('div', {
    staticClass: "bonus__desc-card-bg"
  }, [_c('div', {
    staticClass: "bonus__desc-card-mobile"
  }, [_c('UserBonusCardBalance', {
    attrs: {
      "show-code": false,
      "height": "335px",
      "data": _vm.bonusData,
      "animation-balance": true,
      "user-auth": _vm.userAuth
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "bonus__desc-card-text"
  }, [_vm._v("\n            Копите бонусы и оплачивайте ими ваши покупки\n          ")])], 1)]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "bonus__main-title"
  }, [_vm._v("\n        Копите бонусы бесконечно и просто\n      ")]), _vm._v(" "), _c('h3', {
    staticClass: "bonus__main-title-mobile h3"
  }, [_vm._v("\n        Как получить бонусные рубли?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "bonus__main-blocks"
  }, [_c('div', {
    staticClass: "bonus__block bonus__block_one"
  }, [_c('h4', {
    staticClass: "bonus__block_one-title"
  }, [_vm._v("\n            Покупайте любимые товары\n          ")]), _vm._v(" "), _c('h5', {
    staticClass: "bonus__block_one-title-mobile h5"
  }, [_vm._v("\n            Совершайте покупки\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "bonus__block_one-desc"
  }, [_vm._v("\n            Получайте бонусы за каждую онлайн и офлайн покупку, главное не забудьте зарегистрироваться\n          ")]), _vm._v(" "), _c('nuxt-link', {
    staticClass: "bonus__block_one-btn",
    attrs: {
      "to": "/catalog/"
    }
  }, [_vm._v("\n            Перейти в каталог\n          ")])], 1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "bonus__app"
  }, [_c('h1', {
    staticClass: "bonus__app-title",
    class: [{
      'bonus__app-title-mt': !_vm.userAuth
    }]
  }, [_vm._v("\n        Тратить бонусы легко!\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "bonus__app-blocks"
  }, [_c('div', {
    staticClass: "bonus__app-block"
  }, [_c('div', {
    staticClass: "bonus__app-block bonus__app-block_one"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "bonus__app-links"
  }, [_c('a', {
    staticClass: "bonus__app-link bonus__app-link_one",
    attrs: {
      "href": _vm.appStoreUrl,
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "bonus__app-link bonus__app-link_two",
    attrs: {
      "href": _vm.googlePlay,
      "target": "_blank"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bonus__app-links-mobile"
  }, [_c('a', {
    staticClass: "bonus__app-link bonus__app-link_one",
    attrs: {
      "href": _vm.appStoreUrl,
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "bonus__app-link bonus__app-link_two",
    attrs: {
      "href": _vm.googlePlay,
      "target": "_blank"
    }
  })]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "bonus__app-forms"
  }, [_c('UIActionList', {
    attrs: {
      "actions": {
        sendConfirmCode: _vm.$api.auth.sendConfirmCode,
        checkCodeAndLogin: _vm.$api.auth.checkCodeAndLogin
      }
    },
    on: {
      "checkCodeAndLogin:success": function ($event) {
        var _$event$checkCodeAndL, _$event$checkCodeAndL2;

        return _vm.onSuccess((_$event$checkCodeAndL = $event.checkCodeAndLogin) === null || _$event$checkCodeAndL === void 0 ? void 0 : (_$event$checkCodeAndL2 = _$event$checkCodeAndL.response) === null || _$event$checkCodeAndL2 === void 0 ? void 0 : _$event$checkCodeAndL2.result);
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var sendConfirmCode = _ref.sendConfirmCode,
            checkCodeAndLogin = _ref.checkCodeAndLogin;
        return [_c('BPCardAuthForm', {
          attrs: {
            "send-confirm-code": sendConfirmCode,
            "check-code-and-login": checkCodeAndLogin
          },
          on: {
            "submit": function ($event) {
              return _vm.handleCaptchaSubmit(sendConfirmCode.request, $event);
            },
            "check": checkCodeAndLogin.request
          }
        })];
      }
    }])
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "bonus__questions"
  }, [_c('h2', {
    staticClass: "h2 bonus__questions-title"
  }, [_vm._v("\n        Часто задаваемые вопросы\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "bonus__info-questions"
  }, [_c('ViewportToogle', {
    scopedSlots: _vm._u([{
      key: "desktop",
      fn: function () {
        return [_c('BPSlider', {
          attrs: {
            "list": _vm.questions
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var el = _ref2.el;
              return [_c('BPQuestion', {
                attrs: {
                  "item": el
                }
              })];
            }
          }])
        })];
      },
      proxy: true
    }, {
      key: "mobile",
      fn: function () {
        return [_c('RowSliderNew', {
          attrs: {
            "list": _vm.questions
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref3) {
              var el = _ref3.el;
              return [_c('BPQuestion', {
                attrs: {
                  "item": el
                }
              })];
            }
          }])
        })];
      },
      proxy: true
    }])
  })], 1)]), _vm._v(" "), _c('UIActionList', {
    attrs: {
      "actions": {
        sendConfirmCode: _vm.$api.auth.sendConfirmCode,
        checkCodeAndLogin: _vm.$api.auth.checkCodeAndLogin
      }
    },
    on: {
      "checkCodeAndLogin:success": function ($event) {
        var _$event$checkCodeAndL3, _$event$checkCodeAndL4;

        return _vm.onSuccess((_$event$checkCodeAndL3 = $event.checkCodeAndLogin) === null || _$event$checkCodeAndL3 === void 0 ? void 0 : (_$event$checkCodeAndL4 = _$event$checkCodeAndL3.response) === null || _$event$checkCodeAndL4 === void 0 ? void 0 : _$event$checkCodeAndL4.result);
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref4) {
        var sendConfirmCode = _ref4.sendConfirmCode,
            checkCodeAndLogin = _ref4.checkCodeAndLogin;
        return [_c('BPGiftAuthForm', {
          attrs: {
            "send-confirm-code": sendConfirmCode,
            "check-code-and-login": checkCodeAndLogin
          },
          on: {
            "submit": function ($event) {
              return _vm.handleCaptchaSubmit(sendConfirmCode.request, $event);
            },
            "check": checkCodeAndLogin.request
          }
        })];
      }
    }])
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "faq"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "auto"
    }
  }, [_c('h2', {
    staticClass: "h2 bonus__info-title"
  }, [_vm._v("\n          Условия бонусной программы\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bonus__info-conditions"
  }, [_c('BonusCardCondition', {
    attrs: {
      "view": _vm.viewType
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bonus__info-app"
  }, [_c('div', {
    ref: "observerEl",
    staticClass: "bonus__info-app-wrap"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "bonus__info-layer"
  }, [_c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "bonus__info-layer-mobile",
    attrs: {
      "src": require(("~/assets/images/bonus/" + (_vm.mobileType) + ".png"))
    }
  })])])])])])], 1)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bonus__desc-img"
  }, [_c('img', {
    staticClass: "bonus__desc-img-el",
    attrs: {
      "src": require("assets/images/bonus/bonus-info.png"),
      "srcset": require("assets/images/bonus/bonus-info.png") + " 1x, " + require("assets/images/bonus/bonus-info@2x.png") + " 2x"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bonus__desc-img-mobile"
  }, [_c('img', {
    staticClass: "bonus__desc-img-el",
    attrs: {
      "src": require("assets/images/bonus/bonus-info_mobile.png"),
      "srcset": require("assets/images/bonus/bonus-info_mobile.png") + " 1x, " + require("assets/images/bonus/bonus-info_mobile@2x.png") + " 2x"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bonus__block bonus__block_two"
  }, [_c('div', {
    staticClass: "bonus__block-wrap"
  }, [_c('h4', {
    staticClass: "bonus__block_two-title"
  }, [_vm._v("\n              Проявляйте активность\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "bonus__block_two-desc"
  }, [_vm._v("\n              Делитесь впечатлениями, участвуйте в акциях, проходите опросы и приглашайте друзей\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bonus__block_two-ellipse"
  })])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bonus__app-block-content"
  }, [_c('h3', {
    staticClass: "bonus__app-block-title"
  }, [_vm._v("\n                На сайте и в приложении\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "bonus__app-block-desc"
  }, [_vm._v("\n                Выберите нужное количество бонусов при оформлении заказа - готово!\n              ")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bonus__app-block-wrap"
  }, [_c('div', {
    staticClass: "bonus__app-block bonus__app-block_two"
  }, [_c('h3', {
    staticClass: "bonus__app-block-title"
  }, [_vm._v("\n                На кассе в магазине\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "bonus__app-block-desc"
  }, [_vm._v("\n                Просто покажите кассиру вашу бонусную или назовите номер, к которому она привязана\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "bonus__app-block-layer"
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bonus__info-app-block"
  }, [_c('h2', {
    staticClass: "bonus__info-app-title"
  }, [_vm._v("\n              Ура, вы все прочитали!\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "bonus__info-app-desc"
  }, [_vm._v("\n              Осталось скачать приложение\n            ")])]);
}]

export { render, staticRenderFns }